import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { useContext, useEffect, useState } from "react";
import UserProfileViewModel from "../Admin/User/ViewModels/UserProfileViewModel";
import { APIContext } from "../Contexts/APIContext";
import ChangeNameDialog from "./ChangeNameDialog";
import ChangePasswordDialog from "./ChangePasswordDialog";
import Button from "@mui/material/Button";

export default function AccountPage() {
    const { get } = useContext(APIContext);
    const [user, setUser] = useState<UserProfileViewModel>();
    const [changePasswordOpen, setChangePasswordOpen] = useState(false);
    const [changeNameOpen, setChangeNameOpen] = useState(false);

    useEffect(() => {
        getData();
    }, []);


    const getData = () => {
        get('Auth', 'GetUserProfile', setUser);
    }

    const closeDialog = () => {
        getData();
        setChangePasswordOpen(false);
        setChangeNameOpen(false);
    };

    return (
        <Grid container component={Paper} sx={{ p: 4, maxWidth: 600, margin: "auto", mt: 5, borderRadius: 2, boxShadow: 3 }}>
            <Typography variant="h4" sx={{ mb: 3, width: "100%", textAlign: "center" }}>Account Information</Typography>

            <Grid container alignItems="center">
                <Grid size={4}>
                    <Typography variant="h6">Name:</Typography>
                </Grid>
                <Grid size={8}>
                    <Typography variant="body1">{user?.firstName} {user?.lastName}</Typography>
                </Grid>

                <Grid size={4}>
                    <Typography variant="h6">Email:</Typography>
                </Grid>
                <Grid size={8}>
                    <Typography variant="body1">{user?.email}</Typography>
                </Grid>

                <Grid size={6}>
                    <Button onClick={() => setChangePasswordOpen(true)}>Change Password</Button>
                </Grid>
                <Grid size={6}>
                    <Button onClick={() => setChangeNameOpen(true)}>Change Name</Button>
                </Grid>

            </Grid>



            <ChangePasswordDialog user={user} dialogOpen={changePasswordOpen} handleClose={closeDialog} />

            <ChangeNameDialog user={user} dialogOpen={changeNameOpen} handleClose={closeDialog} />
        </Grid>
    );
}